export default __webpack_public_path__ + "static/media/info.f1f0124d.svg";